import React, { useState, useEffect, createContext } from "react";
import { useProductListSearch } from "../hooks/useAllCategoryData";

export const ProductContext = createContext();

export default function ProductContextProvider({ children }) {
  const data = localStorage.getItem("productLocation");
  const parseData = JSON.parse(data);
  //const { data: products } = useProductListSearch(parseData.categoryName);
  //console.log(products)
  const [allProducts, setAllProducts] = useState();
  const [productList, setProductList] = useState();
  const [filterState, setFilterState] = useState({
    sort: "",
    department: [],
    categories: [],
    brands: [],
    size: [],
  });


  return (
    <ProductContext.Provider
      value={{
        productList
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}
